/*
  JDG Leather Swatch Selector — Natuzzi
Tiered by grade: A0 (base) | 15 (+$245) | 20 (+$375) | 25 (+$500)
  Images: Natuzzi Editions Coverings — June 2026
*/
(function () {

  /* ── Swatch images: full variant title → Natuzzi supplier image ── */
  var SW = {
    /* GRADE A0 — DENVER (+$375) */
    "10B4 - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0B4.jpg",
    "10B5 - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0B5.jpg",
    "10B6 - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0B6.jpg",
    "10B7 - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0B7.jpg",
    "10BF - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BF.jpg",
    "10BH - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BH.jpg",
    "10BI - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BI.jpg",
    "10BK - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BK.jpg",
    "10BL - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BL.jpg",
    "10BR - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BR.jpg",
    "10BS - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BS.jpg",
    "10BT - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BT.jpg",
    "10BU - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BU.jpg",
    "10BY - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BY.jpg",
    "10BZ - DENVER": "https://newsuppliers.natuzzi.com/CreditCard/A0BZ.jpg",

    /* GRADE 15 — LE MANS (base) */
    "1575 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/1575.jpg",
    "1576 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/1576.jpg",
    "1581 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/1581.jpg",
    "1582 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/1582.jpg",
    "1583 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/1583.jpg",
    "15C1 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15C1.jpg",
    "15C3 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15C3.jpg",
    "15C4 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15C4.jpg",
    "15C5 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15C5.jpg",
    "15C6 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15C6.jpg",
    "15CI - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15CI.jpg",
    "15CQ - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15CQ.jpg",
    "15CT - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15CT.jpg",
    "15CW - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15CW.jpg",
    "15CY - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15CY.jpg",
    "15D1 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D1.jpg",
    "15D2 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D2.jpg",
    "15D4 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D4.jpg",
    "15D5 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D5.jpg",
    "15D7 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D7.jpg",
    "15D8 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15D8.jpg",
    "15F1 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F1.jpg",
    "15F2 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F2.jpg",
    "15F3 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F3.jpg",
    "15F5 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F5.jpg",
    "15F8 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F8.jpg",
    "15F9 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15F9.jpg",
    "15Y1 - LE MANS": "https://newsuppliers.natuzzi.com/CreditCard/15Y1.jpg",

    /* GRADE 15 — ARIZONA (base) */
    "15B1 - ARIZONA": "https://newsuppliers.natuzzi.com/CreditCard/15B1.jpg",
    "15B2 - ARIZONA": "https://newsuppliers.natuzzi.com/CreditCard/15B2.jpg",
    "15B3 - ARIZONA": "https://newsuppliers.natuzzi.com/CreditCard/15B3.jpg",

    /* GRADE 15 — OREGON (base) */
    "15WB - OREGON": "https://newsuppliers.natuzzi.com/CreditCard/15WB.jpg",
    "15WE - OREGON": "https://newsuppliers.natuzzi.com/CreditCard/15WE.jpg",
    "15WI - OREGON": "https://newsuppliers.natuzzi.com/CreditCard/15WI.jpg",
    "15WL - OREGON": "https://newsuppliers.natuzzi.com/CreditCard/15WL.jpg",
    "15WQ - OREGON": "https://newsuppliers.natuzzi.com/CreditCard/15WQ.jpg",
    "15OA - YELLOWSTONE": "https://newsuppliers.natuzzi.com/CreditCard/15OA.jpg",
    "15OB - YELLOWSTONE": "https://newsuppliers.natuzzi.com/CreditCard/15OB.jpg",
    "15OD - YELLOWSTONE": "https://newsuppliers.natuzzi.com/CreditCard/15OD.jpg",
    "15OE - YELLOWSTONE": "https://newsuppliers.natuzzi.com/CreditCard/15OE.jpg",

    /* GRADE 20 — DREAM (+$125) */
    "20J1 - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20J1.jpg",
    "20J2 - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20J2.jpg",
    "20J3 - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20J3.jpg",
    "20J4 - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20J4.jpg",
    "20J5 - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20J5.jpg",
    "20JE - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JE.jpg",
    "20JF - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JF.jpg",
    "20JG - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JG.jpg",
    "20JH - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JH.jpg",
    "20JI - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JI.jpg",
    "20JJ - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JJ.jpg",
    "20JK - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JK.jpg",
    "20JL - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JL.jpg",
    "20JQ - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JQ.jpg",
    "20JR - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JR.jpg",
    "20JV - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JV.jpg",
    "20JX - DREAM": "https://newsuppliers.natuzzi.com/CreditCard/20JX.jpg",

    /* GRADE 20 — MADISON (+$125) */
    "20RA - MADISON": "https://newsuppliers.natuzzi.com/CreditCard/20RA.jpg",
    "20RB - MADISON": "https://newsuppliers.natuzzi.com/CreditCard/20RB.jpg",
    "20RE - MADISON": "https://newsuppliers.natuzzi.com/CreditCard/20RE.jpg",

    /* GRADE 25 — LEISURE (+$250) */
    "25VA - LEISURE": "https://newsuppliers.natuzzi.com/CreditCard/25VA.jpg",
    "25VE - LEISURE": "https://newsuppliers.natuzzi.com/CreditCard/25VE.jpg",
    "25VI - LEISURE": "https://newsuppliers.natuzzi.com/CreditCard/25VI.jpg",
    "25VL - LEISURE": "https://newsuppliers.natuzzi.com/CreditCard/25VL.jpg",
    "25VM - LEISURE": "https://newsuppliers.natuzzi.com/CreditCard/25VM.jpg",

    /* GRADE 25 — SONORA (+$250) */
    "25YA - SONORA": "https://newsuppliers.natuzzi.com/CreditCard/25YA.jpg",
    "25YB - SONORA": "https://newsuppliers.natuzzi.com/CreditCard/25YB.jpg",
    "25YC - SONORA": "https://newsuppliers.natuzzi.com/CreditCard/25YC.jpg",
    "25YD - SONORA": "https://newsuppliers.natuzzi.com/CreditCard/25YD.jpg"
  };

  /* ── Tier config ── */
var TIERS = [
    { grade: 'A0', label: 'Grade A0',  upcharge: '',      badge: 'Base',    test: function(c){ return /^10/.test(c); } },
    { grade: '15', label: 'Grade 15',  upcharge: '+$245', badge: '',        test: function(c){ return /^(15|1575|1576|1581|1582|1583)/.test(c); } },
    { grade: '20', label: 'Grade 20',  upcharge: '+$375', badge: '',        test: function(c){ return /^20/.test(c); } },
    { grade: '25', label: 'Grade 25',  upcharge: '+$500', badge: '',        test: function(c){ return /^25/.test(c); } }
  ];

  function getTier(variantTitle) {
    var code = variantTitle.split(' - ')[0] || '';
    for (var i = 0; i < TIERS.length; i++) {
      if (TIERS[i].test(code)) return TIERS[i];
    }
    return TIERS[0];
  }

  /* ── Family descriptions ── */
  var FAM = {
    'DENVER':      { label: 'Denver Full-Grain',    desc: 'Semi-aniline full-grain leather. Soft hand-feel with natural grain. Ages beautifully.' },
    'LE MANS':     { label: 'Le Mans Corrected',    desc: 'Corrected-grain leather with a uniform, elegant finish. Highly durable.' },
    'ARIZONA':     { label: 'Arizona Waxed',        desc: 'Pull-up waxed leather. Develops a rich patina over time.' },
    'OREGON':      { label: 'Oregon Split-Grain',   desc: 'Contemporary matte split-grain leather. Smooth modern feel.' },
    'YELLOWSTONE': { label: 'Yellowstone Nubuck',   desc: 'Soft nubuck-finish leather with a velvety texture. Luxuriously tactile.' },
    'DREAM':       { label: 'Dream Protected',      desc: 'Protected full-grain leather. Excellent durability and easy to clean.' },
    'MADISON':     { label: 'Madison Waxed',        desc: 'Classic waxed pull-up leather with a vintage character.' },
    'LEISURE':     { label: 'Leisure Aniline',      desc: 'Pure aniline leather. The softest, most natural feel available.' },
    'SONORA':      { label: 'Sonora Aniline',       desc: 'Full aniline leather with exceptional softness and breathability.' }
  };

  /* ── CSS ── */
  var s = document.createElement('style');
  s.textContent =
    '.jdg-sw-tier{margin-bottom:14px}' +
    '.jdg-sw-tier-hdr{display:flex;align-items:center;justify-content:space-between;padding:5px 10px;background:#f5f2ee;border-radius:6px;margin-bottom:7px}' +
    '.jdg-sw-tier-hdr.a0{background:#FDF6E3;border:1px solid #E8C97A}' +
    '.jdg-sw-tier-name{font-size:11px;font-weight:700;color:#333;text-transform:uppercase;letter-spacing:.06em;display:flex;align-items:center;gap:6px}' +
    '.jdg-sw-tier-premium{font-size:9px;background:#8B6914;color:#fff;padding:2px 6px;border-radius:8px;text-transform:uppercase;letter-spacing:.04em}' +
    '.jdg-sw-tier-price{font-size:11px;font-weight:700;color:#555}' +
    '.jdg-sw-tier-hdr.a0 .jdg-sw-tier-price{color:#8B6914}' +
    '.jdg-sw-grid{display:flex;flex-wrap:wrap;gap:7px}' +
    '.jdg-sw-tile{width:58px;height:58px;flex-shrink:0;position:relative;border:2px solid #D4CCC3;border-radius:6px;overflow:hidden;cursor:pointer;background:#f5f0ea;transition:border-color .15s,transform .15s}' +
    '.jdg-sw-tile:hover{border-color:#8A7F75;transform:scale(1.1);z-index:5}' +
    '.jdg-sw-tile.on{border-color:#1c1c1c;box-shadow:0 0 0 2px #1c1c1c}' +
    '.jdg-sw-tile img{width:100%;height:100%;object-fit:cover;display:block;pointer-events:none}' +
    '.jdg-sw-tile.on::after{content:"✓";position:absolute;top:2px;right:3px;width:14px;height:14px;background:#1c1c1c;color:#fff;font-size:9px;border-radius:50%;display:flex;align-items:center;justify-content:center;line-height:14px;text-align:center;font-weight:bold}' +
    '.jdg-sw-tip{position:absolute;bottom:calc(100% + 6px);left:50%;transform:translateX(-50%);background:rgba(28,28,28,.9);color:#fff;font-size:10px;white-space:nowrap;padding:3px 8px;border-radius:4px;pointer-events:none;opacity:0;transition:opacity .12s;z-index:20}' +
    '.jdg-sw-tip::after{content:"";position:absolute;top:100%;left:50%;transform:translateX(-50%);border:4px solid transparent;border-top-color:rgba(28,28,28,.9)}' +
    '.jdg-sw-tile:hover .jdg-sw-tip{opacity:1}' +
    '#jdg-zoom{position:fixed;z-index:99999;width:280px;background:#fff;border:1px solid #e0d8d0;border-radius:10px;box-shadow:0 12px 48px rgba(0,0,0,.22);overflow:hidden;opacity:0;transform:scale(.92) translateY(6px);transition:opacity .2s,transform .2s;pointer-events:none}' +
    '#jdg-zoom.on{opacity:1;transform:scale(1) translateY(0);pointer-events:auto}' +
    '#jdg-zoom .zi{width:100%;aspect-ratio:1;overflow:hidden;background:#f5f0ea}' +
    '#jdg-zoom .zi img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .3s}' +
    '#jdg-zoom.on .zi img{transform:scale(1.05)}' +
    '#jdg-zoom .zb{padding:14px 16px 16px}' +
    '#jdg-zoom .zcode{font-size:18px;font-weight:600;color:#1c1c1c;letter-spacing:.06em;margin-bottom:2px}' +
    '#jdg-zoom .zgrade{font-size:10px;letter-spacing:.15em;text-transform:uppercase;color:#8B6914;font-weight:600;margin-bottom:2px}' +
    '#jdg-zoom .zfam{font-size:10px;letter-spacing:.2em;text-transform:uppercase;color:#B89A6A;font-weight:500;margin-bottom:8px}' +
    '#jdg-zoom .zdesc{font-size:12px;color:#6B6560;line-height:1.6;margin-bottom:10px}' +
    '#jdg-zoom .zbadge{font-size:10px;color:#8A7F75;letter-spacing:.08em;border-top:1px solid #ece7e0;padding-top:8px}';
  document.head.appendChild(s);

  /* ── Zoom popup ── */
  var zEl, zImg, zCode, zGrade, zFam, zDesc, hideT;

  function buildZoom() {
    if (document.getElementById('jdg-zoom')) {
      zEl    = document.getElementById('jdg-zoom');
      zImg   = zEl.querySelector('.zi img');
      zCode  = zEl.querySelector('.zcode');
      zGrade = zEl.querySelector('.zgrade');
      zFam   = zEl.querySelector('.zfam');
      zDesc  = zEl.querySelector('.zdesc');
      return;
    }
    zEl = document.createElement('div');
    zEl.id = 'jdg-zoom';
    zEl.innerHTML =
      '<div class="zi"><img src="" alt=""></div>' +
      '<div class="zb">' +
        '<div class="zcode"></div>' +
        '<div class="zgrade"></div>' +
        '<div class="zfam"></div>' +
        '<div class="zdesc"></div>' +
        '<div class="zbadge">\uD83C\uDDEE\uD83C\uDDF9 Exclusive Natuzzi Italian Leather</div>' +
      '</div>';
    document.body.appendChild(zEl);
    zImg   = zEl.querySelector('.zi img');
    zCode  = zEl.querySelector('.zcode');
    zGrade = zEl.querySelector('.zgrade');
    zFam   = zEl.querySelector('.zfam');
    zDesc  = zEl.querySelector('.zdesc');
    zEl.addEventListener('mouseenter', function(){ clearTimeout(hideT); });
    zEl.addEventListener('mouseleave', scheduleHide);
  }

  function showZoom(tile, val, url) {
    clearTimeout(hideT);
    buildZoom();
    var parts  = val.split(' - ');
    var code   = parts[0] || val;
    var fam    = parts[1] || '';
    var info   = FAM[fam] || { label: fam, desc: '' };
    var tier   = getTier(val);
    zImg.src           = url;
    zCode.textContent  = code;
    zGrade.textContent = tier.label + (tier.upcharge ? '  ' + tier.upcharge : '  Included');
    zFam.textContent   = info.label;
    zDesc.textContent  = info.desc;

    var pw = 280, gap = 16;
    var imgEl = document.querySelector('.jdg-product-main-img');
    var sy = window.scrollY;
    var top, left;
    if (imgEl) {
      var ir = imgEl.getBoundingClientRect();
      top  = ir.top + sy + (ir.height / 2) - 160;
      left = ir.right + gap;
      if (left + pw > window.innerWidth - 8) left = ir.left - pw - gap;
      top  = Math.max(sy + 8, top);
    } else {
      var r = tile.getBoundingClientRect();
      top  = r.top + sy - 330;
      left = Math.max(8, r.left - pw - gap);
    }
    zEl.style.cssText = 'top:'+top+'px;left:'+left+'px;width:'+pw+'px';
    zEl.classList.add('on');
  }

  function scheduleHide() {
    hideT = setTimeout(function(){ if(zEl) zEl.classList.remove('on'); }, 220);
  }

  /* ── Main init ── */
  function init() {
    document.querySelectorAll('.jdg-pp-opt-group').forEach(function(group) {
      var lbl = group.querySelector('.jdg-pp-opt-lbl');
      if (!lbl) return;
      var optName = lbl.textContent.replace(/:.*/, '').trim();
      if (optName !== 'Leather') return;

      var btnRow = group.querySelector('.jdg-pp-opt-row');
      if (!btnRow || btnRow.dataset.sw) return;
      btnRow.dataset.sw = '1';

      var btns = Array.from(btnRow.querySelectorAll('.jdg-pp-ob'));
      if (!btns.length) return;

      /* Group buttons by tier */
      var tierMap = {};
      btns.forEach(function(btn) {
        var val  = btn.dataset.v;
        var tier = getTier(val);
        if (!tierMap[tier.grade]) tierMap[tier.grade] = { tier: tier, btns: [] };
        tierMap[tier.grade].btns.push(btn);
      });

      /* Render: one section per tier */
      var wrap = document.createElement('div');
      wrap.className = 'jdg-sw-wrap';

  ['A0','15','20','25'].forEach(function(grade) {
        if (!tierMap[grade]) return;
        var group = tierMap[grade];
        var tier  = group.tier;

        var section = document.createElement('div');
        section.className = 'jdg-sw-tier';

        /* Tier header */
        var hdr = document.createElement('div');
        hdr.className = 'jdg-sw-tier-hdr' + (grade === 'A0' ? ' a0' : '');

        var nameEl = document.createElement('span');
        nameEl.className = 'jdg-sw-tier-name';
        nameEl.textContent = tier.label;
        if (tier.badge) {
          var badgeEl = document.createElement('span');
          badgeEl.className = 'jdg-sw-tier-premium';
          badgeEl.textContent = tier.badge;
          nameEl.appendChild(badgeEl);
        }

        var priceEl = document.createElement('span');
        priceEl.className = 'jdg-sw-tier-price';
        priceEl.textContent = tier.upcharge || 'Included';

        hdr.appendChild(nameEl);
        hdr.appendChild(priceEl);
        section.appendChild(hdr);

        /* Swatch grid */
        var grid = document.createElement('div');
        grid.className = 'jdg-sw-grid';

        group.btns.forEach(function(btn) {
          var val = btn.dataset.v;
          var url = SW[val];

          var tile = document.createElement('div');
          tile.className = 'jdg-sw-tile' + (btn.classList.contains('on') ? ' on' : '');

          if (url) {
            var img = document.createElement('img');
            img.src = url; img.alt = val; img.loading = 'lazy';
            tile.appendChild(img);
          }

          var tip = document.createElement('div');
          tip.className = 'jdg-sw-tip';
          tip.textContent = val;
          tile.appendChild(tip);

          /* Hover zoom */
          var ht;
          tile.addEventListener('mouseenter', function() {
            if (!url) return;
            ht = setTimeout(function(){ showZoom(tile, val, url); }, 200);
          });
          tile.addEventListener('mouseleave', function() {
            clearTimeout(ht); scheduleHide();
          });

          /* Click → trigger original button */
          tile.addEventListener('click', function() {
            btn.click();
            wrap.querySelectorAll('.jdg-sw-tile').forEach(function(t){ t.classList.remove('on'); });
            tile.classList.add('on');
            var sp = lbl.querySelector('span');
            if (sp) {
              var tierInfo = getTier(val);
              sp.textContent = val + (tierInfo.upcharge ? '  (' + tierInfo.upcharge + ')' : '');
            }
          });

          /* Sync with native button state */
          new MutationObserver(function() {
            tile.classList.toggle('on', btn.classList.contains('on'));
          }).observe(btn, { attributes: true, attributeFilter: ['class'] });

          grid.appendChild(tile);
        });

        section.appendChild(grid);
        wrap.appendChild(section);
      });

      /* Hide text buttons, insert swatch sections */
      btnRow.style.cssText = 'display:none!important';
      btnRow.parentNode.insertBefore(wrap, btnRow.nextSibling);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(init, 150); });
  } else {
    setTimeout(init, 150);
  }

})();